<header class="workspace-header">
  <div class="header-and-subtitle">
    <h1 class="section-title">
      {{ requirement()?.name ?? ('requirementIntake.details.header.defaultTitle' | translate) }}
    </h1>
    @if (requirement()?.category) {
      <span
        ><span>Section · </span><span>{{ requirement()?.category }}</span></span
      >
    }
  </div>
  @if (hasSelection() && !isLoading() && !hasError()) {
    <comp-intake-state-pill [status]="effectiveStatus()"></comp-intake-state-pill>
  }
</header>

@if (!hasSelection()) {
  <section class="workspace-empty">
    <h3 class="surface-title">{{ 'requirementIntake.details.empty.title' | translate }}</h3>
    <p class="workspace-caption">
      {{ 'requirementIntake.details.empty.description' | translate }}
    </p>
  </section>
} @else if (isLoading()) {
  <section class="workspace-surface">
    <p class="workspace-caption">{{ 'requirementIntake.details.loading' | translate }}</p>
  </section>
} @else if (hasError()) {
  <section class="workspace-surface">
    <p class="field-error">
      {{ 'requirementIntake.details.error' | translate }}
    </p>
  </section>
} @else {
  @if (requirement(); as requirement) {
    <h4 class="surface-title uppercase">
      {{ 'requirementIntake.details.description.title' | translate }}
    </h4>
    <div class="description" [innerHtml]="htmlDescription()"></div>
    @if (requirement.referenceWorkspaces.length > 0) {
      <section class="workspace-surface collapsible">
        <button
          type="button"
          class="collapse-section"
          [class.collapse-section-expanded]="expandedSections().referenceElements"
          [attr.aria-expanded]="expandedSections().referenceElements"
          (click)="toggleSectionExpanded('referenceElements')"
        >
          <div class="icon">
            <!-- Angular Material "star" icon -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="20px"
              viewBox="0 -960 960 960"
              width="20px"
              fill="#2563eb"
            >
              <path
                d="m352-293 128-76 129 76-34-144 111-95-147-13-59-137-59 137-147 13 112 95-34 144ZM243-144l63-266L96-589l276-24 108-251 108 252 276 23-210 179 63 266-237-141-237 141Zm237-333Z"
              />
            </svg>
          </div>
          <span translate="requirementIntake.details.referenceElements.collapsibleHeadline"></span>
          <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              fill="none"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div
          class="content-area-wrapper"
          [class.content-area-wrapper-expanded]="expandedSections().referenceElements"
        >
          <div class="content-area">
            <comp-reference-elements
              [referenceWorkspaces]="requirement.referenceWorkspaces"
            ></comp-reference-elements>
          </div>
        </div>
      </section>
    }
    @if (requirement.examples.length > 0) {
      <section class="workspace-surface collapsible">
        <button
          type="button"
          class="collapse-section"
          [class.collapse-section-expanded]="expandedSections().examples"
          [attr.aria-expanded]="expandedSections().examples"
          (click)="toggleSectionExpanded('examples')"
        >
          <div class="icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#2563EB"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <path d="M12 16v-4"></path>
              <path d="M12 8h.01"></path>
            </svg>
          </div>
          <span
            translate="requirementIntake.details.aboutThisRequirement.collapsibleHeadline"
          ></span>
          <svg class="chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              fill="none"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        <div
          class="content-area-wrapper"
          [class.content-area-wrapper-expanded]="expandedSections().examples"
        >
          <div class="content-area">
            <comp-examples [examples]="requirement.examples" [showHeadline]="false"></comp-examples>
          </div>
        </div>
      </section>
    }
    <comp-applicability-section
      [requirement]="requirement"
      [collapsed]="defaultCollapsed()"
      [isSubmitPending]="isSubmitPending()"
      [actionMessage]="actionMessage()"
      (applicabilityConfirmed)="applicabilityConfirmed.emit($event)"
    ></comp-applicability-section>

    @if (requirement.intakeStatus !== IntakeStatus.NotApplicable) {
      <comp-evidence-slots
        [requirement]="requirement"
        [collapsed]="defaultCollapsed()"
        (notifyReloadNeeded)="notifyReloadNeeded.emit($event)"
      ></comp-evidence-slots>

      @if (showFindingsSection()) {
        <section class="workspace-surface margin-top">
          <comp-ev-findings
            [requirement]="requirement"
            [refreshTrigger]="findingsRefreshTrigger()"
            [findingsType]="requirement.name.includes('SBOM') ? 'dtrack' : 'default'"
          ></comp-ev-findings>
        </section>
      }
      @if (showVerdictWidget()) {
        <comp-verdict-widget
          [requirement]="requirement"
          [isSubmitPending]="isSubmitPending()"
          [actionMessage]="actionMessage()"
          (verdictSaveRequested)="verdictSaveRequested.emit($event)"
        ></comp-verdict-widget>
      }
    } @else {
      <section class="workspace-surface">
        <p class="workspace-caption">
          {{ 'requirementIntake.details.unavailable' | translate }}
        </p>
      </section>
    }
  }
}
